<template>
  <Widget title="Text Notifications">
      <template v-slot:icon>
          <i class="fas fa-message" style="font-size:30px; color: #036"></i>
      </template>

      <div class="text-right">
        <button type="button" class="btn btn-sm btn-light" style="max-height: 30px; overflow: hidden" @click="stopAllNotifications">
          <i class="fa fa-stop fa-fw" aria-hidden="true"></i>
          Stop All Notifications
        </button>
      </div>

      <form @submit="submit">
        <div class="form-group">
          <label for="txtDisplayText">Display Text</label>
          <textarea required rows="2" type="text" class="form-control" id="txtDisplayText" v-model="display_text" />
        </div>

        <div class="form-group">
          <label for="ddlZone">Zone</label>
          <select required class="form-control" id="ddlZone" v-model="zone_selected">
            <option :key="zone.zone_id" v-for="zone in zones_for_drop_down" :value="zone">{{ zone.label }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="ddlFlasherType">Flasher Type</label>
          <select required class="form-control" id="ddlFlasherType" v-model="flasher_type">
            <option value="off">Off</option>
            <option value="on">On</option>
            <option value="simultaneously">Simultaneously</option>ßß
            <option value="alternately">Alternately</option>
          </select>
        </div>

        <div class="form-group">
          <label for="txtDuration">Duration</label>
          <input required type="number" min="1" max="600" class="form-control" id="txtDuration" v-model="duration">
        </div>

        <button type="submit" class="btn btn-hub-primary">Send Text Notification</button>
      </form>
  </Widget>
</template>

<script>
import vSelect from 'vue-select';
import { mapGetters } from 'vuex'

import Widget from '../Widget.vue';

export default {
  components: { Widget, vSelect },
  data() { 
    return {
      display_text: '',
      zone_selected: null,
      flasher_type: 'off',
      action: 'start',
      duration: 20
    }
  },
  computed: {
      ...mapGetters({
        zones: 'allZones',
      }),
      isStandardUser() {
          return this.is_authenticated && [1,2,3,4].includes(this.logged_in_user.group_id)
      },
      zones_for_drop_down() {
        return this.zones.map(zone => ({ label: zone.name, value: zone.zone_id }));
      }
  },
  methods: {
    submit() {
      var notification = {
        display_text: this.display_text,
        zone_id: this.zone_selected ? this.zone_selected.value : null,
        flasher_type: this.flasher_type,
        action: this.action,
        duration: parseInt(this.duration)
      }
      this.$store.dispatch('playTextNotification', notification);

      this.display_text = '';
      this.zone_selected = null;
      this.flasher_type = 'off';
      this.action = 'start';
      this.duration = 20;
    },
    stopAllNotifications() {
      this.action = 'stop';
      this.submit();
    }
  },
  created() {
    this.$store.dispatch('getZones');
  }
}
</script>